





















































































import { Component, Mixins, Prop, Vue } from 'vue-property-decorator'
import { mapState, mapActions, mapGetters} from 'vuex'
import Loading  from '@/components/Loading.vue'
import NoData from '@/components/NoData.vue'
import TranslateMixin from '@/mixins/translate'
import { setStyle } from '@/utils/style';
import { InitData } from '@/model'
import { getPara } from '@/utils/util'

// setStyle();

@Component({
  computed: mapGetters([
    'clubRanking',
    'clubPref',
    'initData',
  ]),
  methods: mapActions([
    'getClubRanking',
    'getClubPref',
    'setClubPref',
  ]),
  components: {
    Loading,
    NoData
  }
})
export default class extends Mixins(TranslateMixin) {

  private query!: any;
  private clubRanking!: any;
  private clubPref!: any;
  getClubRanking!: (params: object) => Promise<void>;
  getClubPref!: (params: any) => Promise<void>;
  setClubPref!: (params: any) => Promise<void>;
  initData!: InitData;
  private openid = '';
  private clubId = '';
  private empty = false;
  private myUserInfo = null;
  private daily = null;
  private weekly = null;
  private clientLang = getPara('lang', location.href) || 'en'; // en
  private ticket = getPara('ticket', location.href);
  private showSetting = false;
  private showSettingDialog = false;
  private showQuestionDialog = false;
  private leaveClubRanking = true; // 不参加排名
  private beforeSetting = false; // 设置前的状态
  private settingClick = false; 

  async created() {
    this.query = this.$route.query
    console.log('** test params:', this.query);
    const { id, openid } = this.query;
    this.openid = openid;
    this.clubId = id
    this.loadData();
  }

  destroyed () {
    this.settingClick = false;
  }

  private async loadData () {
    try {
      await this.getClubRanking({
        club_id: this.clubId,
        openid: this.openid,
        ticket: this.ticket,
        lang: this.clientLang
      });
      if (this.clubRanking.error) {
        this.empty = true;
        return;
      }
      const { myUserInfo, daily, weekly } = this.clubRanking;
      this.myUserInfo = myUserInfo;
      this.daily = daily as any;
      this.weekly = weekly as any;
      if (daily.ranking?.length == 0 && weekly.ranking?.length == 0) {
        this.empty = true;
      } else {
        this.empty = false;
      }
      if (this.myUserInfo) {
        this.showSetting = true;
      } else {
        this.showSetting = false;
      }
      await this.getClubPref({
        club_id: this.clubId,
        openid: this.openid,
        ticket: this.ticket,
        lang: this.clientLang
      });
      const { pref } = this.clubPref || {};
      this.leaveClubRanking = pref && pref.leaveClubRanking;
      this.beforeSetting = this.leaveClubRanking;
    } catch (e) {
      console.error('loadData error:', e)
      this.empty = true;
      this.showSetting = false;
      this.leaveClubRanking = true;
    }
  }

  private setting () {
    // if (this.settingClick) {
    //   return;
    // }
    // this.settingClick = true
    this.showSettingDialog = !this.showSettingDialog;
    this.beforeSetting = this.leaveClubRanking;
  }

  private question () {
    this.showQuestionDialog = !this.showQuestionDialog;
  }

  private changePolicy () {
    this.beforeSetting = !this.beforeSetting;
  }

  private async confirmPref () {
    try {
      await this.setClubPref({
        club_id: this.clubId,
        openid: this.openid,
        ticket: this.ticket,
        lang: this.clientLang,
        target: "leave_club_ranking",
        pref: {"leave_club_ranking": this.beforeSetting}
      });
      if (this.initData.setClubPrefRes === 0) {
        this.loadData()
      }
    } catch (e) {
      console.error('loadData error:', e)
    } finally {
      this.setting();
    }
  }

}
